import type { JSX } from 'react';
import { formatLongDate } from '../calendar/format';
import { nights } from '../calendar/monthGrid';
import { useLocale, useT } from '../i18n/useT';
import type { BookingDraft } from './bookingForm';
import { toE164 } from './phone';

export const ConfirmStep = ({
  draft,
  ownerName
}: {
  draft: BookingDraft;
  ownerName: string | null;
}): JSX.Element => {
  const t = useT();
  const locale = useLocale();
  const count = draft.from !== '' && draft.to !== '' ? nights(draft.from, draft.to) : 0;
  const visitor =
    draft.bookingFor === 'self'
      ? ownerName === null || ownerName.trim() === ''
        ? t('you')
        : t('{0} (you)', { 0: ownerName })
      : `${draft.visitorName.trim()}, ${toE164(draft.visitorCountry, draft.visitorPhone) ?? draft.visitorPhone.trim()}`;
  return (
    <>
      <h3 className="ow-step-heading" tabIndex={-1} data-step-heading>
        {t('Check and confirm')}
      </h3>
      <dl className="ow-details">
        {draft.kind === 'block' ? (
          <>
            <dt>{t('Type')}</dt>
            <dd>{t('Maintenance')}</dd>
          </>
        ) : (
          <>
            <dt>{t('Who is staying')}</dt>
            <dd>{visitor}</dd>
          </>
        )}
        <dt>{t('Dates')}</dt>
        <dd>
          {draft.from !== '' && formatLongDate(draft.from, locale)} –{' '}
          {draft.to !== '' && formatLongDate(draft.to, locale)}
        </dd>
        <dt>{t('Nights')}</dt>
        <dd>{count === 1 ? t('1 night') : t('{0} nights', { 0: count })}</dd>
        {draft.comment.trim() !== '' && (
          <>
            <dt>{t('Comment')}</dt>
            <dd>{draft.comment.trim()}</dd>
          </>
        )}
      </dl>
    </>
  );
};
